import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ADVANCED_SEARCH_SETTINGS_DEFAULTS, SelectOption } from '../../../../interfaces/advancedSearch.interface';

@Component({
    selector: 'app-advanced-search-select',
    templateUrl: './advanced-search-select.component.html',
    styleUrls: ['./advanced-search-select.component.scss']
})
export class AdvancedSearchSelectComponent implements OnInit, OnChanges {

    @Input() control: FormControl;
    @Input() label: string;
    @Input() options: SelectOption[];

    @Output('valueChanged') valueChangedEvEm = new EventEmitter();

    readonly DEFAULTS = ADVANCED_SEARCH_SETTINGS_DEFAULTS;

    constructor() { }

    ngOnInit(): void { }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.control) {
            if (this.options && this.options.length > 0) {
                this.control.enable();
            } else {
                this.control.disable();
            }
        }
    }

    valueChanged(val) {
        this.valueChangedEvEm.emit();
    }
}
